import REST from './rest';

class JongjonanAPI extends REST {
    constructor() {
        super();
        this.baseURL = `${window.config.baseurl}wp-json/jongjonan/v1`;
    }

    /**
     * Fetch Guests
     */
    fetchGuests(params = { page: 1 }) {
        return this._request('get', 'guests', params);
    }

    /**
     * Fetch single Guest
     */
    fetchGuest(id) {
        return this._request('get', `guests/${id}`);
    }

    /**
     * Save Guest
     */
    saveGuest(id, params) {
        return this._request('put', `guests/${id}`, null, params);
    }

    /**
     * Fetch Instansi
     */
    fetchInstansi() {
        return this._request('get', 'instansi');
    }

    /**
     * Fetch stats
     */
    fetchStats() {
        return this._request('get', 'stats');
    }
}

const api = new JongjonanAPI();

export default api;



// WEBPACK FOOTER //
// ./src/api/jongjonan.js